import type { DtoApplication } from "@porchpass/api-client";
import {
  getMainBorrowerIdFromApplication,
  getAuthBorrowerInfo,
  getBorrowerFromApplicationById,
  getIdsFromPath,
} from "src/utils";
import type { ApplicationNavigationGuardParams } from "src/types/dashboard";
import { setInvitedMainBorrowerUserData } from "./handleMainBorrowerInviteRoute";
import { setInvitedCoBorrowerUserData } from "./handleCoborrowerInviteRoute";
import { setRedirectedUserData } from "./handleRedirectParam";

export const handleApplicationNavigationGuard = (
  response: DtoApplication,
  { firebaseUser, setUserData }: ApplicationNavigationGuardParams,
) => {
  const authBorrower = getAuthBorrowerInfo(response, firebaseUser);
  const mainBorrower = getMainBorrowerIdFromApplication(response);

  const { status, is_primary, id: auth_borrower_id } = authBorrower;

  if (is_primary && status === "INVITED") {
    setInvitedMainBorrowerUserData(
      response,
      authBorrower,
      mainBorrower,
      setUserData,
    );
    return;
  }

  if (!is_primary && status === "INVITED" && auth_borrower_id) {
    setInvitedCoBorrowerUserData(
      response,
      authBorrower,
      mainBorrower,
      setUserData,
    );
    return;
  }

  const pathIds = getIdsFromPath();
  const redirectBorrower = getBorrowerFromApplicationById(
    response,
    pathIds.borrower_id,
  );

  setRedirectedUserData(
    response,
    authBorrower,
    mainBorrower,
    redirectBorrower,
    setUserData,
  );
};
